<template>
  <Wizzard
    title="Add Liability"
    name="Liability"
    :modal
    :preset
    :steps="STEPS_LIST"
    :transaction-type="TRANSACTION_TYPE"
    :asset-type="ASSET_TYPE"
    :asset-classes-list="ASSET_CLASSES_LIST"
    :investment-strategies-list="INVESTMENT_STRATEGIES_LIST"
    disable-values-step
  />
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { ModalClass } from '@types'
import { InputWizardPreset } from '../utils/types'

import {
  ASSET_CLASSES_LIST,
  ASSET_TYPE,
  INVESTMENT_STRATEGIES_LIST,
  STEPS_LIST,
  TRANSACTION_TYPE,
} from './utils/const'

import Wizzard from '../components/Wizzard.vue'

type Props = {
  modal: ModalClass<any>
  preset?: InputWizardPreset
}

defineProps<Props>()

provide('assetCostLabel', 'Amount')
provide('assetDateLabel', 'Date of borrowing')
provide('assetNamePlaceholder', 'Bank Credit Line')
</script>
